/* mad-wizard-steps-1.js: the step "opening", "Your opening" (was "Where it goes, how big, how it arrives"; Codex
   rewrite table, redesign of 2026-09-26).
   Release B (Seth 2026-10-12: "make the form very very organized so that people dont get confused"; "some things are a
   little self-explanatory"): where the door goes (Interior or Exterior, required, nothing chosen), what was measured as
   three visible tiles (Rough opening, chosen first; Finished opening; Not measured yet), the size as whole inches plus a
   list of eighths (an iPhone number pad has no fraction keys; "36 1/2" is saved exactly as before, mad-wizard-core.js
   inchesField), the honest fit result, and the resize question when the fit says so. How the door opens, the pair and
   the frame moved to "How it hangs" (mad-wizard-steps-23.js); the "Not a swinging door?" and "I have a finished
   opening instead" links are gone with them (they were bound again on every open and went dead on every second one).
   No listeners here: the core hands every change to sync().
   "Not measured yet" stays (Seth, 2026-10-11): 3 of the 4 customized doors requested in the first two days of the new
   site had not been measured. Picking it saves not_measured '1' and leaves opening_type at its last measured value,
   exactly what the old tick box saved. No "Not sure" answers and no call in the step's wording (one place to call, at
   the end of the request). Registers with MadWizard (core). */
(function () {
  'use strict';
  var W = window.MadWizard; if (!W || W.step1Loaded) return; W.step1Loaded = true;
  var h = W.h, tile = W.tile, money = W.money;
  function E() { return window.MADEstimate; }
  function BOOK() { return window.MAD_PRICE_BOOK || {}; }
  function P(k) { return Number((BOOK().prices || {})[k]) || 0; }

  /* Off the form since 2026-10-01 (Seth); still the source of the How it works drawing (mad-start-here). */
  var DIAGRAM =
    '<svg class="mad-diagram" viewBox="0 0 320 142" width="320" height="142" aria-hidden="true" focusable="false">' +
      '<rect x="8" y="8" width="304" height="126" fill="none" stroke="currentColor" stroke-opacity=".25"/>' +
      '<g stroke="currentColor" stroke-opacity=".25" stroke-dasharray="4 4"><line x1="60" y1="8" x2="60" y2="134"/><line x1="260" y1="8" x2="260" y2="134"/></g>' +
      /* the door keeps its 110 x 92 proportions (taller than wide); the drawing grew 12 units instead */
      '<rect x="105" y="42" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2.5"/>' +
      /* QA Q-12: the Width label sits inside the frame (its top line is y 8), above its arrow, never on a line */
      '<g stroke="currentColor" stroke-width="1.5" fill="currentColor" font-size="13" font-family="inherit">' +
        '<line x1="105" y1="34" x2="215" y2="34"/><polygon points="105,34 111,30 111,38"/><polygon points="215,34 209,30 209,38"/>' +
        '<text x="160" y="27" text-anchor="middle" stroke="none">Width</text>' +
        '<line x1="228" y1="42" x2="228" y2="134"/><polygon points="228,42 224,48 232,48"/><polygon points="228,134 224,128 232,128"/>' +
        '<text x="236" y="92" stroke="none">Height</text></g></svg>';

  /* what was measured: 'rough', 'finished' or 'none' (Not measured yet) */
  function measured(r) { return r.not_measured === '1' ? 'none' : r.opening_type === 'finished' ? 'finished' : 'rough'; }
  function sizeHelp(m) {
    return m === 'finished' ? 'Inside the frame: side to side, and floor to the top.' : 'Stud to stud, and floor to header. ' + E().roughOpeningText(BOOK());
  }

  function render(state) {
    var r = state.raw, m = measured(r), door = W.thisDoor(state), Q = W.question;
    return '' +
      Q('int_ext', 'Where will ' + door + ' go?', '<div class="mad-tiles">' +
        tile({ name: 'int_ext', value: 'interior', label: 'Interior', hint: 'Bedroom, pantry, office', checked: r.int_ext === 'interior' }) +
        tile({ name: 'int_ext', value: 'exterior', label: 'Exterior', hint: 'Entry, patio, weather', checked: r.int_ext === 'exterior' }) +
      '</div>') +

      Q('opening_type', 'What did you measure?', '<div class="mad-tiles mad-tiles--3 mad-tiles--stack-sm">' +
        tile({ name: 'opening_type', value: 'rough', label: 'Rough opening', hint: 'The framed hole, no door frame yet', checked: m === 'rough' }) +
        tile({ name: 'opening_type', value: 'finished', label: 'Finished opening', hint: 'A door frame is already in place', checked: m === 'finished' }) +
        tile({ name: 'opening_type', value: 'none', label: 'Not measured yet', hint: 'Add the size later', checked: m === 'none' }) +
      '</div>') +

      Q('opening_size', 'Opening size', '<p class="mad-help" data-mad-size-help>' + h(sizeHelp(m)) + '</p>' +
        '<div class="mad-row mad-row--inches">' + W.inchesField('opening_width', 'Width', r.opening_width, '38') + W.inchesField('opening_height', 'Height', r.opening_height, '83') + '</div>' +
        '<div class="mad-fit" data-mad-fit-readout data-state="unmeasured" hidden><div><p class="mad-fit__text" data-mad-fit-text></p><p class="mad-fit__sub" data-mad-fit-sub></p>' +
          '<p class="mad-fit__sub" data-mad-fit-tolerance hidden>' + h(E().toleranceText(BOOK())) + '</p></div></div>',
        { attrs: ' data-mad-size', hidden: m === 'none' }) +

      /* resize: asked only when the fit result is "Needs resizing"; nothing chosen first. Its price is the resize line,
         the whole difference it makes to the total */
      Q('resize', 'Should we resize ' + door + ' for your opening?', '<div class="mad-tiles">' +
        tile({ name: 'resize', value: 'yes', label: 'Yes, resize it', hint: 'Cut down or built up to your opening', price: '+' + money(P('resize_yes')), checked: r.resize === 'yes' }) +
        tile({ name: 'resize', value: 'no', label: 'No, ship it as listed', hint: 'Your installer handles the fit', price: 'Included', checked: r.resize === 'no' }) +
      '</div>', { attrs: ' data-mad-resize-confirm', hidden: true });
  }

  function sync(panel, state) {
    var r = state.raw;
    ['int_ext', 'resize'].forEach(function (n) { var el = panel.querySelector('input[name="' + n + '"]:checked'); if (el) r[n] = el.value; });
    var ot = panel.querySelector('input[name="opening_type"]:checked');
    if (ot) { if (ot.value === 'none') r.not_measured = '1'; else { r.not_measured = ''; r.opening_type = ot.value; } }
    ['opening_width', 'opening_height'].forEach(function (n) { var v = W.readInches(panel, n); if (v !== null) r[n] = v; });
  }
  function change(panel, state, e) { W.inchesEvent(panel, e); sync(panel, state); }

  function refresh(panel, state) {
    var r = state.raw, m = measured(r);
    var size = panel.querySelector('[data-mad-size]'); if (size) size.hidden = m === 'none';
    var help = panel.querySelector('[data-mad-size-help]'); if (help) help.textContent = sizeHelp(m);
    var readout = panel.querySelector('[data-mad-fit-readout]'), confirm = panel.querySelector('[data-mad-resize-confirm]');
    /* Not measured yet: its tile says it, so no fit box */
    var opening = W.openingFor(r), fit = W.fitFor(r), show = m !== 'none' && !!opening;
    if (readout) readout.hidden = !show;
    if (show && readout) {
      var text = panel.querySelector('[data-mad-fit-text]'), sub = panel.querySelector('[data-mad-fit-sub]');
      readout.setAttribute('data-state', fit.state);
      /* R04: no trusted size (the product page holds it back, or the listing has none): no fit result is read from
         the title; the heading says "Size to be confirmed" and the opening goes to review (fit_readout talk) */
      var noSize = fit.reason === 'no_slab_size';
      /* Seth 2026-10-13: an arched door is resized in height like any door; only its width never changes. The resize
         price shows only while the prices switch is on (Theme settings > Quote funnel). */
      var head = noSize ? E().SIZE_TO_CONFIRM : { close: 'Close match', resize: 'Needs resizing' + (W.showPrices() ? ' (+' + money(P('resize_yes')) + ')' : ''), talk: fit.reason === 'arched_width' ? 'Arched doors keep their width' : 'This opening needs a closer look', unmeasured: 'Not measured yet' }[fit.state];
      text.textContent = head;
      /* The heading already says it: the line under it starts after the heading's own words, so "Close match" is
         said once (polish, 2026-09-26, screenshot 099). FIT_TEXT itself, which the Fit line property sends, is unchanged. */
      var said = (noSize ? E().SIZE_TO_CONFIRM_TEXT : E().FIT_TEXT[fit.state]) || '';
      if (said.indexOf(head + '. ') === 0) said = said.slice(head.length + 2);
      sub.textContent = said + (state.slab ? ' Listed slab: ' + E().formatSlab(state.slab) + '.' : '');
      var tol = panel.querySelector('[data-mad-fit-tolerance]'); if (tol) tol.hidden = fit.state === 'unmeasured' || !state.slab;
    }
    var needConfirm = show && fit.state === 'resize';
    if (confirm) confirm.hidden = !needConfirm;
    if (!needConfirm) { r.resize = ''; var c = panel.querySelector('input[name="resize"]:checked'); if (c) c.checked = false; }
  }

  /* Every answer this step still needs, read from the saved answers only (the core marks them all at once, lists
     them under the buttons, and asks the first missing step before a door is saved) */
  function check(state) {
    var r = state.raw, out = [];
    if (!r.int_ext) out.push({ q: 'int_ext', name: 'Where it goes', msg: 'Choose interior or exterior.' });
    if (r.not_measured !== '1') {
      var w = E().parseInches(r.opening_width), hgt = E().parseInches(r.opening_height);
      if (!w || !hgt) {
        out.push({ q: 'opening_size', name: 'Opening size', msg: !w && !hgt ? 'Type the width and height in inches.' : !w ? 'Type the width in inches.' : 'Type the height in inches.',
          fields: (w ? [] : ['opening_width']).concat(hgt ? [] : ['opening_height']) });
      } else if (W.fitFor(r, state).state === 'resize' && r.resize !== 'yes' && r.resize !== 'no') {
        out.push({ q: 'resize', name: 'Resize', msg: 'Choose whether we resize ' + W.thisDoor(state) + '.' });
      }
    }
    return out;
  }

  W.registerStep('opening', {
    title: 'Your opening', short: 'Opening',
    topics: ['place', 'int_ext', 'opening', 'measure', 'size', 'resize'],
    render: render, sync: sync, change: change, input: change, refresh: refresh, check: check
  });
})();
